import { FC } from "react";

import Points from "web/Layout/Common/Points";

import WalletIcon from "web/assets/icons/wallet.svg";

import type { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import PointsSkeleton from "web/Layout/Common/Points/PointsSkeleton/pointsSkeleton";
import defaultClasses from "./customer.scss";

interface INavigationPanelAdditionalCustomeProps {
  totalPoints?: number;
  showSkeleton?: boolean;
}

const NavigationPanelAdditionalCustomer: FC<
  PropsWithClasses<INavigationPanelAdditionalCustomeProps>
> = ({ classes = {}, totalPoints, showSkeleton }) => {
  return (
    <div className={classes.root}>
      {showSkeleton ?
        <PointsSkeleton />
        : (
          <>
            <WalletIcon className={classes.icon} width={22} />
            <Points className={classes.points} points={totalPoints} />
          </>
        )}
    </div>
  );
};

export default classify(defaultClasses)(NavigationPanelAdditionalCustomer);
